"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tright: 25px;\n\ttop: 0;\n\tcolor: #000;\n\tfont-size: 30px;\n\tfont-weight: bold;\n\t&:hover,\n\t&:focus {\n\t\tcolor: red;\n\t\tcursor: pointer;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Close = _styledComponents.default.span(_templateObject());

var _default = Close;
exports.default = _default;

//# sourceMappingURL=Close.js.map